// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "1c0e0f4dff15bb12a72a" + ".bundle.js";
};